export const findRowInPath = (path: HTMLElement[]) => {
  const rowEl = path.find(
    (element) => element.dataset && element.dataset.row,
  ) as HTMLDivElement | undefined;

  return rowEl?.dataset.row;
};
